import Api from '@/api/Api'
import store from '../store'

export default {

  async getDebits () {
    return store.dispatch('checkResponseApi', await Api().get('accounting/debits'))
  },

  async getListJournalEntries (params) {
    return store.dispatch('checkResponseApi', await Api().get('accounting/journal-entries', { params }))
  },

  async getSingleJournalEntries (jvId) {
    return store.dispatch('checkResponseApi', await Api().get(`accounting/journal-entries/${jvId}`))
  },

  async getNextCodeJournalEntries () {
    return store.dispatch('checkResponseApi', await Api().get('accounting/journal-entries/latest_code'))
  },

  async insertJournalEntries (data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('accounting/journal-entries', data, options))
  },

  async updateJournalEntries (jvId, data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put(`accounting/journal-entries/${jvId}`, data, options))
  },

  async updateStatusJournalEntries (jvId, data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put(`accounting/journal-entries/${jvId}/status`, data, options))
  },

  async deleteJournalEntries (jvId) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete(`accounting/journal-entries/${jvId}`, {}, options))
  },

  async getChartOfAccounts (params) {
    return store.dispatch('checkResponseApi', await Api().get('chart-of-accounts', { params }))
  },

  async getAccountsListChartOfAccounts () {
    return store.dispatch('checkResponseApi', await Api().get('chart-of-accounts/list'))
  },

  async insertChartOfAccounts (data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().post('chart-of-accounts', data, options))
  },

  async updateChartOfAccounts (accountId, data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put(`chart-of-accounts/${accountId}`, data, options))
  },

  async deleteChartOfAccounts (accountId) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete(`chart-of-accounts/${accountId}`, {}, options))
  },

  async updateJournalSetDefault (data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('accounting/settings/journal/set-default', data, options))
  },

  async updateJournalAutomatedAccountsMapping (data) {
    const options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().put('accounting/settings/journal/automated-accounts-mapping', data, options))
  },

}



// WEBPACK FOOTER //
// ./src/api/AccountingService.js